import { margin } from "@mui/system";
import React from "react";
import DotsComponent from "../../DotsComponent";
import "../IDcard/IDCard.css";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';

const TeamsIDCard = () => {
  return (
    <>
      <div className="container" style={{ marginLeft: "0",height:'312px' }}>
        <DotsComponent />
        <div style={{ textAlign: "center", padding: "5px" }}>
          <small>Members details</small>
        </div>
        <div className="sub-container">
          <div className="active" style={{ backgroundColor: "#FEBD3E" }}>
            <div className="active-text"> Inactive</div>
          </div>

          <div className="allDetailsBox">
            <div>
              <div className="customername">
                <span>Member Name</span>
                <small style={{ fontSize: "12px" }}>
                  Joined On: 18th Aug 2022{" "}
                </small>
              </div>

              <div className="details">
                <span>
                  Role: <b>Designer</b>
                </span>
                <label>Email ID :jonach.123@gmail.com </label>
                <span>
                  {" "}
                  Contact details: <b>+91-7833516223</b>
                </span>
                <span>
                  {" "}
                  Deadline: <b>20.08.2023</b>
                </span>
                <span>
                  {" "}
                  Project: <b>1</b>
                </span>
                <span>
                  {" "}
                  Teams Name: <b>1</b>
                </span>
              </div>
            </div>
            <div>
            <div className="crm-toggle">
            <FormControlLabel
        control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
        
      />
      </div>
              <div className="image"></div>
              
            </div>
          </div>
          <div
            style={{
              textDecoration: "underline",
              textAlign: "right",
              marginRight: "10px",
              display: "flex",
              justifyContent:'flex-end' 
            }}
          >
            <div style={{ margin: "4px", alignItems: "right"}}>
              <DeleteIcon style={{ color: "#F24E1E" }} />
            </div>
            <small style={{ marginTop: "7px" }}>Delete team member</small>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamsIDCard;

export const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 30,
  height: 15,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 10.3,
    height: 10.3,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));